// components/Modal.jsx
import React from 'react';

function Modal({ isOpen, onClose, title, actions, children }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    e.stopPropagation(); // Prevent bubbling from modal
  };

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={handleOverlayClick}>
        <div className="modal-header">
          <div>{title && <h3>{title}</h3>}</div>
          <div className="close-x" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </div>
        </div>
        <div className="modal-content">{children}</div>
        <div className="modal-actions">
          {actions?.map((action, i) =>
            action.render
              ? <span key={i}>{action.render()}</span>
              : (
                <button
                  key={i}
                  type="button"
                  className={action.className || 'btn'}
                  onClick={action.onClick}
                >
                  {action.label}
                </button>
              )
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;
